const MAX_ERRORS = 20;
const errorLog = [];

function push(entry) {
    errorLog.push(entry);
    if (errorLog.length > MAX_ERRORS) errorLog.shift();
}

export function initErrorLogger() {
    // Uncaught JS errors
    window.addEventListener('error', (e) => {
        push({
            type: 'uncaught_error', message: e.message,
            source: e.filename, line: e.lineno,
            col: e.colno, stack: e.error?.stack || null,
            time: new Date().toISOString(),
        });
    });

    // Unhandled promise rejections
    window.addEventListener('unhandledrejection', (e) => {
        push({
            type: 'unhandledrejection',
            message: String(e.reason?.message || e.reason),
            stack: e.reason?.stack || null,
            time: new Date().toISOString(),
        });
    });

    // console.log, console.error and console.warn
    const _log = console.log.bind(console);
    const _error = console.error.bind(console);
    const _warn = console.warn.bind(console);

    console.log = (...args) => {
        push({ type: 'console.log', message: args.map(String).join(' '), time: new Date().toISOString() });
        _log(...args);
    };

    console.error = (...args) => {
        push({ type: 'console.error', message: args.map(String).join(' '), time: new Date().toISOString() });
        _error(...args);
    };

    console.warn = (...args) => {
        push({ type: 'console.warn', message: args.map(String).join(' '), time: new Date().toISOString() });
        _warn(...args);
    };
}

export function getErrorLog() {
    return [...errorLog];
}
